<template>
  <section>
    <div class="wrap">
      <div class="section-head">
        <div class="left">
          <span class="eyebrow"><span class="dot"></span>{{ labelsState['lv_testimonials_eyebrow'] || 'Results' }}</span>
          <h2>{{ labelsState['lv_testimonials_heading_pre'] || 'Hear it from our' }} <span class="grad-text">{{ labelsState['lv_testimonials_heading_grad'] || 'customers.' }}</span></h2>
        </div>
        <div class="right">{{ labelsState['lv_testimonials_desc'] || 'Teams that reclaimed hours and multiplied their conversions.' }}</div>
      </div>
      <div class="testimonials">
        <article v-for="t in testimonials" :key="t.who" class="testimonial">
          <blockquote>{{ labelsState[t.quoteKey] || t.quote }}</blockquote>
          <footer>
            <div class="t-avatar" :style="{ background: t.gradient }">{{ t.initials }}</div>
            <div>
              <div class="who">{{ t.who }}</div>
              <div class="role">{{ t.role }}</div>
            </div>
          </footer>
        </article>
      </div>
    </div>
  </section>
</template>

<script>
import { computed, onMounted } from 'vue';
import { useLabelsStore } from '@/stores/labels';
import { useLanguageStore } from '@/stores/language';

export default {
  name: 'TestimonialsV2',
  setup() {
    const labelsStore = useLabelsStore();
    const languageStore = useLanguageStore();
    onMounted(() => labelsStore.fetchAndSetLabels(languageStore.language));
    return { labelsState: computed(() => labelsStore.labels) };
  },
  data() {
    return {
      testimonials: [
        {
          quoteKey: 'lv_testimonial_flora_quote',
          quote: 'In two weeks the assistant was handling 84% of queries. My team went back to selling instead of explaining prices.',
          who: 'María Vargas',
          role: 'Head of CX · Flora Cosmética',
          initials: 'MV',
          gradient: 'linear-gradient(135deg, var(--green), var(--blue))',
        },
        {
          quoteKey: 'lv_testimonial_clinica_quote',
          quote: 'We went from losing appointments on weekends to a full calendar. The WhatsApp integration was 1 click.',
          who: 'Dr. Julián Soler',
          role: 'Director · Clínica Norte/Star',
          initials: 'JS',
          gradient: 'linear-gradient(135deg, var(--cyan), var(--green))',
        },
        {
          quoteKey: 'lv_testimonial_veloce_quote',
          quote: 'We tried 3 other platforms. NQA was the only one that truly understood commercial Spanish and our real catalog.',
          who: 'Andrea Lema',
          role: 'CMO · Veloce Motors',
          initials: 'AL',
          gradient: 'linear-gradient(135deg, var(--blue), var(--violet))',
        },
      ],
    };
  },
};
</script>
